import { DashboardWrapper } from '../../container/dashboardWrapper'
import {
    Container,
    MainContentWrapper
} from '../../styles/account'
import {
    SupportTopWrapper,
    MainContent,
} from '../../styles/support'
import { Button } from '../../components/button'
import { SupportTicket } from '../../components/support-ticket/support-ticket'
import { CustomModal } from '../../components/modal'
import { useState } from 'react'
import { InputWrapper } from '../../components/input/input.style'
import { Input } from '../../components/input'
import { Textarea } from '../../components/textarea'

const Support = () => {
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <CustomModal title="Open Ticket" onClose={() => setShowModal(false)} showModal={showModal}>
                <InputWrapper>
                    <Input
                        type="text"
                        fullWidth
                        placeholder="Title"
                        required
                    />
                </InputWrapper>
                <InputWrapper>
                    <Textarea
                        required
                        placeholder="Message"
                        fullWidth
                    />
                </InputWrapper>
            </CustomModal>
            <DashboardWrapper>
                <SupportTopWrapper>
                    <Container>
                        <MainContent>
                            <div className="page-title">
                                <p>CONTACT DETAILS</p>
                            </div>
                            <div className="top">
                                <h1 className="school-name">Klassconnect</h1>
                            </div>
                            <div className="bottom">
                                <div className="school-address">
                                    <p className="school-address-1">65, Aiport Estate, Garka Abuja.
                                    </p>
                                    <p className="school-address-2">16-30 Illupeju bypass, Lagos State.</p>
                                </div>
                                <div className="school-email">
                                    <p className="school-email-1">info@Klassconnect.com
                                    </p>
                                    <p className="school-email-2">helpme@Klassconnect.com</p>
                                </div>
                                <div className="contact-info">
                                    <p className="contact-info-1">01 -54853244
                                    </p>
                                    <p className="contact-info-2">+2348154512542</p>
                                </div>
                            </div>
                            <div className="button-container">
                                <Button
                                    variant="secondary"
                                    onClick={() => setShowModal(true)}
                                >
                                    create new TICKET

                                </Button>
                            </div>

                        </MainContent>
                    </Container>
                </SupportTopWrapper>
                <MainContentWrapper>
                    <MainContent>
                        <Container>
                            <SupportTicket category="open" />
                            <SupportTicket category="closed" />
                        </Container>
                    </MainContent>
                </MainContentWrapper>

            </DashboardWrapper>
        </>
    )
}

export default Support
